import { useContext, useEffect } from 'react'

import { AppRouter, AuthContext } from 'components'

import './App.css'

import {
    detectBrowserWithVersion,
    envConfig,
    getOS,
    registerUserInAnalytics
} from 'modules'

function App() {
    const { user } = useContext(AuthContext)

    useEffect(() => {
        if (user) {
            // Identify user in Sentry + FullStory with the same props
            registerUserInAnalytics({
                uid: user.uid,
                env: envConfig.firebaseConfig.projectId,
                ...detectBrowserWithVersion(),
                ...getOS()
            })
        }
    }, [user])

    return <AppRouter />
}

export default App
